<template>
    <div class="edit-profile o-flex o-flex-center">
        <div class="avatar-wrap">
            <img :src="profilePhoto('small')">

            <div v-if="auth.user?.photo?.approved === 0" class="pending-overlay">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 33 33"><g data-name="Icon feather-clock" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"><path data-name="Path 65" d="M31.5 16.5a15 15 0 1 1-15-15 15 15 0 0 1 15 15Z"/><path data-name="Path 66" d="M16.5 7.5v9l6 3"/></g></svg>
                </span>
            </div>
        </div>
        <div class="edit-profile__content">
            <h2 class="o-flex o-flex--center"><svg class="verified-icon mr--" v-if="auth.user.profile_verified_at" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32"><g data-name="Group 121"><path data-name="Polygon 2" d="M14.51 1.665a2 2 0 0 1 2.98 0l1.268 1.417a2 2 0 0 0 2.018.6l1.821-.5a2 2 0 0 1 2.5 1.606l.315 1.924a2 2 0 0 0 1.366 1.578l1.834.587a2 2 0 0 1 1.23 2.69l-.776 1.819a2 2 0 0 0 .294 2.055l1.251 1.523a2 2 0 0 1-.421 2.923l-1.614 1.1a2 2 0 0 0-.861 1.894l.236 1.956a2 2 0 0 1-1.943 2.24l-1.9.041a2 2 0 0 0-1.762 1.137l-.83 1.737a2 2 0 0 1-2.858.838l-1.6-.994a2 2 0 0 0-2.106 0l-1.6.994a2 2 0 0 1-2.858-.838l-.83-1.737a2 2 0 0 0-1.762-1.137l-1.9-.041a2 2 0 0 1-1.943-2.24l.236-1.956a2 2 0 0 0-.861-1.894l-1.614-1.1a2 2 0 0 1-.421-2.923l1.242-1.524a2 2 0 0 0 .294-2.055l-.776-1.819a2 2 0 0 1 1.23-2.69l1.833-.586a2 2 0 0 0 1.364-1.582L6.9 4.784a2 2 0 0 1 2.5-1.606l1.821.5a2 2 0 0 0 2.018-.6Z" fill="#2c7ddb"/><path data-name="Icon metro-checkmark" d="m21.668 9.461-8.165 8.163-3.81-3.81-2.719 2.722 6.529 6.531 10.886-10.885Z" fill="#fff"/></g></svg>{{auth.user.username}}</h2>
            <p>{{auth.user.address}}</p>

            <div v-if="auth.user.gender === TYPE_GENDER_MALE" class="credits-wrap">
                <div class="amount-box">
                    <svg width="31" height="31" xmlns="http://www.w3.org/2000/svg">
                        <image :href="theme === 'sugardaddy' ? require('@/assets/img/dollar-icon.svg') : require('@/assets/img/dollar-icon-luxliebe.svg')" height="31" width="31" />
                    </svg>

                    <!-- <img src="../assets/img/dollar-icon.svg" alt="Dollar icon"> -->
                    {{availableCredits}}
                </div>
                <a @click="buyCreditsClickHandler" href="javascript:void(0)" class="button button--primary">{{$t('general.buy_credits')}}</a>
            </div>

        </div>
    </div>
    <div class="get-verified" v-if="!auth.user.profile_verified_at">
        <svg class="verified-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32"><g data-name="Group 121"><path data-name="Polygon 2" d="M14.51 1.665a2 2 0 0 1 2.98 0l1.268 1.417a2 2 0 0 0 2.018.6l1.821-.5a2 2 0 0 1 2.5 1.606l.315 1.924a2 2 0 0 0 1.366 1.578l1.834.587a2 2 0 0 1 1.23 2.69l-.776 1.819a2 2 0 0 0 .294 2.055l1.251 1.523a2 2 0 0 1-.421 2.923l-1.614 1.1a2 2 0 0 0-.861 1.894l.236 1.956a2 2 0 0 1-1.943 2.24l-1.9.041a2 2 0 0 0-1.762 1.137l-.83 1.737a2 2 0 0 1-2.858.838l-1.6-.994a2 2 0 0 0-2.106 0l-1.6.994a2 2 0 0 1-2.858-.838l-.83-1.737a2 2 0 0 0-1.762-1.137l-1.9-.041a2 2 0 0 1-1.943-2.24l.236-1.956a2 2 0 0 0-.861-1.894l-1.614-1.1a2 2 0 0 1-.421-2.923l1.242-1.524a2 2 0 0 0 .294-2.055l-.776-1.819a2 2 0 0 1 1.23-2.69l1.833-.586a2 2 0 0 0 1.364-1.582L6.9 4.784a2 2 0 0 1 2.5-1.606l1.821.5a2 2 0 0 0 2.018-.6Z" fill="#2c7ddb"/><path data-name="Icon metro-checkmark" d="m21.668 9.461-8.165 8.163-3.81-3.81-2.719 2.722 6.529 6.531 10.886-10.885Z" fill="#fff"/></g></svg>
        <h2>
            <router-link  @click="$emit('close')" class="clr-blue" :to="{name: 'verification'}"><strong>{{$t('search.get_verified')}}</strong></router-link>
        </h2>
        <p>{{$t('profile.quick_simple')}}</p>
    </div>
    <div class="language">
        <ul class="mb0">
            <li>
                <router-link @click="$emit('close')" :to="{name: 'general'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g data-name="Icon feather-edit"><path data-name="Path 56" d="M16.25 22H2.833A2.837 2.837 0 0 1 0 19.167V5.75a2.833 2.833 0 0 1 2.833-2.833h6.708a.917.917 0 0 1 0 1.833H2.833a1 1 0 0 0-1 1v13.417a1 1 0 0 0 1 1H16.25a1 1 0 0 0 1-1v-6.708a.917.917 0 1 1 1.833 0v6.708A2.837 2.837 0 0 1 16.25 22Z"/><path data-name="Path 57" d="M18.442 0a3.558 3.558 0 0 1 2.516 6.074L9.129 17.903a.917.917 0 0 1-.426.241l-4.981 1.245a.917.917 0 0 1-1.112-1.107l1.245-4.981a.917.917 0 0 1 .241-.426l11.83-11.833A3.535 3.535 0 0 1 18.442 0ZM8.012 16.427 19.661 4.782a1.725 1.725 0 0 0-2.439-2.439L5.573 13.988 4.76 17.24Z"/></g></svg> {{ucFirst($t('profile.edit.edit_profile'))}} ({{auth.user.profile_strength}}% {{$t('credits.success.completed').toLowerCase()}})</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'photos'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 23.494 22"><g data-name="Icon feather-camera"><path data-name="Path 60" d="M20.336 22H3.157A3.161 3.161 0 0 1 0 18.843V6.519a3.161 3.161 0 0 1 3.157-3.158h2.5L7.626.408A.917.917 0 0 1 8.389 0h6.722a.917.917 0 0 1 .763.408l1.969 2.953h2.5A3.161 3.161 0 0 1 23.5 6.518v12.325A3.161 3.161 0 0 1 20.336 22ZM3.157 5.194a1.326 1.326 0 0 0-1.324 1.324v12.325a1.326 1.326 0 0 0 1.324 1.324h17.179a1.326 1.326 0 0 0 1.324-1.324V6.519a1.326 1.326 0 0 0-1.324-1.324h-2.987a.917.917 0 0 1-.763-.408l-1.969-2.954H8.876L6.908 4.786a.917.917 0 0 1-.763.408Z"/><path data-name="Path 61" d="M11.749 6.722a5.4 5.4 0 1 1-5.4 5.4 5.4 5.4 0 0 1 5.4-5.4Zm0 8.963a3.565 3.565 0 1 0-3.567-3.563 3.569 3.569 0 0 0 3.567 3.563Z"/></g></svg> {{$t('profile.edit.photo_gallery')}}</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'videos'}"><svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 2px;" width="19" height="22"><path data-name="Icon feather-play" d="m1 1 15.556 10L1 21Z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg> {{$t('profile.edit.video_gallery')}}</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'settings'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g data-name="Icon feather-settings"><path data-name="Path 54" d="M11 5.958A5.042 5.042 0 1 1 5.958 11 5.047 5.047 0 0 1 11 5.958Zm0 8.25A3.208 3.208 0 1 0 7.792 11 3.212 3.212 0 0 0 11 14.208Z"/><path data-name="Path 55" d="M11.073 22a2.753 2.753 0 0 1-2.75-2.75v-.069a.593.593 0 0 0-.39-.537l-.054-.022a.6.6 0 0 0-.654.116l-.051.051A2.751 2.751 0 1 1 3.285 14.9l.051-.051a.593.593 0 0 0 .116-.654v-.009a.6.6 0 0 0-.545-.361H2.75a2.75 2.75 0 0 1 0-5.5h.069a.592.592 0 0 0 .537-.39l.022-.054a.593.593 0 0 0-.116-.654l-.051-.051A2.751 2.751 0 1 1 7.1 3.285l.05.05a.6.6 0 0 0 .654.116.917.917 0 0 1 .182-.059.6.6 0 0 0 .264-.492v-.15a2.75 2.75 0 0 1 5.5 0v.083a.594.594 0 0 0 .361.542h.009a.6.6 0 0 0 .654-.116l.051-.051a2.751 2.751 0 1 1 3.89 3.892l-.05.05a.593.593 0 0 0-.116.654.917.917 0 0 1 .059.182.6.6 0 0 0 .491.261h.152a2.75 2.75 0 0 1 0 5.5h-.082a.594.594 0 0 0-.542.361v.009a.593.593 0 0 0 .116.654l.051.051a2.751 2.751 0 1 1-3.891 3.89l-.051-.051a.6.6 0 0 0-.654-.116h-.009a.6.6 0 0 0-.361.545v.152A2.753 2.753 0 0 1 11.073 22Zm-2.48-5.067a2.416 2.416 0 0 1 1.563 2.213V19.249a.917.917 0 0 0 1.833 0v-.156a2.44 2.44 0 0 1 4.143-1.737l.007.007.055.055a.92.92 0 1 0 1.3-1.3l-.055-.055-.007-.007a2.441 2.441 0 0 1 1.733-4.143h.086a.917.917 0 0 0 0-1.833h-.156a2.429 2.429 0 0 1-2.227-1.472.917.917 0 0 1-.068-.238 2.416 2.416 0 0 1 .556-2.5l.007-.007.055-.055a.92.92 0 1 0-1.3-1.3l-.055.055-.007.007a2.441 2.441 0 0 1-4.143-1.733V2.75a.917.917 0 0 0-1.833 0v.156a2.429 2.429 0 0 1-1.469 2.227.917.917 0 0 1-.242.066 2.43 2.43 0 0 1-2.5-.556l-.009-.007-.055-.055a.92.92 0 1 0-1.3 1.3l.055.055.007.007a2.417 2.417 0 0 1 .5 2.653 2.415 2.415 0 0 1-2.213 1.563h-.1a.917.917 0 1 0 0 1.833h.156a2.441 2.441 0 0 1 1.737 4.143l-.007.007-.055.055a.92.92 0 1 0 1.3 1.3l.055-.055.007-.007a2.429 2.429 0 0 1 2.653-.5Z"/></g></svg> {{$t('navigation.user_menu.settings')}}</router-link>
            </li>
            <li v-if="auth.user.gender === TYPE_GENDER_MALE">
                <router-link @click="$emit('close')" :to="{name: 'credits_log'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g data-name="Group 463"><g data-name="Group 462"><path d="M11 22A11 11 0 0 1 3.222 3.222a11 11 0 1 1 15.556 15.556A10.928 10.928 0 0 1 11 22Zm0-20.167A9.167 9.167 0 1 0 20.167 11 9.177 9.177 0 0 0 11 1.833Z" data-name="Path 58"/></g><path d="m12.68 10.417-2.782-.811a.76.76 0 0 1 .214-1.489h1.707a1.572 1.572 0 0 1 .881.27.4.4 0 0 0 .5-.052l.9-.876a.417.417 0 0 0-.046-.631 3.642 3.642 0 0 0-2.228-.773V4.818a.413.413 0 0 0-.413-.412h-.823a.413.413 0 0 0-.412.412v1.236h-.066a2.822 2.822 0 0 0-2.807 3.081 2.948 2.948 0 0 0 2.158 2.488l2.64.773a.76.76 0 0 1-.213 1.488h-1.709a1.572 1.572 0 0 1-.881-.27.4.4 0 0 0-.5.052l-.9.876a.417.417 0 0 0 .046.631 3.642 3.642 0 0 0 2.228.773v1.236a.413.413 0 0 0 .412.412h.824a.413.413 0 0 0 .412-.412v-1.243a2.909 2.909 0 0 0 2.725-1.872 2.828 2.828 0 0 0-1.867-3.65Z" data-name="Icon awesome-dollar-sign"/></g></svg> {{$t('credits.log.credits_history')}}</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'help'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g data-name="Group 90" transform="translate(-4185 -2183)"><path data-name="Path 58" d="M4196 2205a11 11 0 0 1-7.778-18.778 11 11 0 1 1 15.556 15.556A10.928 10.928 0 0 1 4196 2205Zm0-20.167a9.167 9.167 0 1 0 9.167 9.167 9.177 9.177 0 0 0-9.167-9.167Z"/><path data-name="Path 59" d="M4195.888 2197.341a.917.917 0 0 1-.29-1.787c.034-.011 3.5-1.235 3.5-3.255a3.208 3.208 0 0 0-6.235-1.071.917.917 0 0 1-1.729-.608 5.042 5.042 0 0 1 9.8 1.681c0 3.371-4.558 4.929-4.752 4.993a.916.916 0 0 1-.294.047Z"/><rect data-name="Rectangle 57" width="1.833" height="2.75" rx=".917" transform="translate(4195.082 2198.584)"/></g></svg> {{$t('navigation.user_menu.faq')}}</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'safety'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path data-name="Icon metro-help" d="M11 0a11 11 0 1 0 11 11A11 11 0 0 0 11 0ZM6.875 11A4.125 4.125 0 1 1 11 15.125 4.125 4.125 0 0 1 6.875 11Zm13.019 3.684-3.812-1.579a5.514 5.514 0 0 0 0-4.21l3.812-1.579a9.65 9.65 0 0 1 0 7.368Zm-5.21-12.578-1.579 3.812a5.514 5.514 0 0 0-4.21 0L7.316 2.106a9.65 9.65 0 0 1 7.368 0ZM2.106 7.316l3.812 1.579a5.514 5.514 0 0 0 0 4.21l-3.812 1.579a9.65 9.65 0 0 1 0-7.368Zm5.21 12.578 1.579-3.812a5.514 5.514 0 0 0 4.21 0l1.579 3.812a9.65 9.65 0 0 1-7.368 0Z"/></svg> {{$t('navigation.user_menu.safety_tips')}}</router-link>
            </li>
            <li v-if="auth.user.gender === TYPE_GENDER_MALE">
                <a href="javascript:;" @click="openBeacon"><svg style="margin-right: 30px;" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 22"><path data-name="Icon material-headset-mic" d="M9 0a9 9 0 0 0-9 9v7a3 3 0 0 0 3 3h3v-8H2V9a7 7 0 0 1 14 0v2h-4v8h4v1H9v2h6a3 3 0 0 0 3-3V9a9 9 0 0 0-9-9Z"/></svg>{{$t('general.helpscout.support')}}</a>
            </li>
            <li v-else>
                <router-link @click="$emit('close')" :to="{name: 'contact'}"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 22"><path data-name="Icon material-headset-mic" d="M9 0a9 9 0 0 0-9 9v7a3 3 0 0 0 3 3h3v-8H2V9a7 7 0 0 1 14 0v2h-4v8h4v1H9v2h6a3 3 0 0 0 3-3V9a9 9 0 0 0-9-9Z"/></svg> {{$t('navigation.user_menu.member_support')}}</router-link>
            </li>
            <li>
                <Logout v-if="logged" />
            </li>
        </ul>
    </div>
    <div class="horizontal-line mt mb-"></div>
    <div class="language">
        <LanguageSelection @change="$emit('close')" />
    </div>
    <div class="privacy-terms">
        <ul class="mb0">
            <li>
                <router-link @click="$emit('close')" :to="{name: 'privacy'}">{{$t('navigation.footer.privacy')}}</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'terms'}" href="javascript:;">{{$t('navigation.footer.terms')}}</router-link>
            </li>
            <li>
                <router-link @click="$emit('close')" :to="{name: 'ConsentPolicy'}">{{$t('navigation.footer.consent_policy_headline')}}</router-link>
            </li>

            <li><router-link @click="$emit('close')" :to="{name: 'PrivacyAndRefundPolicy'}">{{$t('navigation.footer.privacy_and_refund_policy_headline')}}</router-link></li>
            <li><router-link @click="$emit('close')" :to="{name: 'SafetyAndAntiScamPolicy'}">{{$t('navigation.footer.safety_and_anti_scam_policy_headline')}}</router-link></li>
            <li><router-link @click="$emit('close')" :to="{name: 'CommunityGuidelinesCodeOfConduct'}">{{$t('navigation.footer.community_guidelines_code_of_conduct_headline')}}</router-link></li>
            <li><router-link @click="$emit('close')" :to="{name: 'CookiePolicy'}">{{$t('navigation.footer.cookie_policy_headline')}}</router-link></li>
            <li><router-link @click="$emit('close')" :to="{name: 'imprint'}">{{$t('general.imprint.imprint')}}</router-link></li>
            <li><router-link @click="$emit('close')" :to="{name: 'anti-slavery'}">{{$t('general.anti_slavery')}}</router-link></li>
            <li><router-link @click="$emit('close')" :to="{name: 'VerificationPrivacy'}">{{$t('navigation.footer.verification_privacy_headline')}}</router-link></li>
          <li><p>{{ supportEmail }}</p></li>


          <li v-if="auth.user.gender === TYPE_GENDER_MALE && theme !== 'luxliebe'">
                <a @click="$emit('close')" target="_blank" href="https://seitensprungzimmer.com/"><span class="clr-gold">Ad</span> ·
                    {{ $t('navigation.rooms') }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";
import Logout from "@/components/auth/Logout";
import LanguageSelection from "@/components/language/LanguageSelection";
import { TYPE_GENDER_MALE } from "@/types/user";
import { ucFirst, capitalize } from "@/utilities/general";
import { requestBuyCreditsRouteHandler } from "@/service/credits";
import { supportEmail } from "@/service/support-email";
import ThemeMixin from "@/mixins/ThemeMixin";


export default {
    name: "ProfileMenu",
    mixins: [AuthenticatedMixin, ThemeMixin],
    components: {Logout, LanguageSelection},
    emits: ['close'],
    props: {
        availableCredits: {
            type: Number,
            default: 0
        }
    },
    computed: {
        supportEmail() {
            return supportEmail()
        }
    },
    methods: {
        ucFirst,
        capitalize,
        buyCreditsClickHandler() {
            this.$emit('close')
            requestBuyCreditsRouteHandler()
        },
        openBeacon() {
            this.$emit('close')
            window.Beacon("open");
        }
    },
    created() {
        this.TYPE_GENDER_MALE = TYPE_GENDER_MALE;
    }

}
</script>

<style lang="scss">
    .language {
        .nav-item {

            .nav-link {
                color: #777777;
                font-weight: 400;
            }
        }
    }
</style>

<style lang="scss" scoped>

    .get-verified {
        padding: 12px 12px 12px 38px;
        border-radius: 10px;
        background-color: #C1DEFF;
        position: relative;
        margin-bottom: 20px;

        .verified-icon {
            position: absolute;
            left: 12px;
            top: 12px;

        }

        h2 {
            font-size: 16px;
            line-height: 1.3;
            margin-bottom: 0;
        }

        p {
            margin-bottom: 0;
            font-size: 16px;
            line-height: 1.3;
            letter-spacing: -0.66px;
        }
    }

    .credits-wrap {
        display: flex;
        flex-wrap: wrap;

        gap: 5px;
        margin-top: 15px;

        .amount-box {
            border-radius: 15px;
            background-color: #F5F5F5;
            padding-left: 40px;
            position: relative;
            display: flex;
            align-items: center;
            font-weight: 700;
            height: 30px;
            min-width: 128px;
            margin-bottom: 5px;

            svg {
                position: absolute;
                top: 0;
                left: 0;
            }

            @media(max-width: 350px) {
                min-width: 105px;
            }
        }

        .button--primary {
            text-transform: capitalize;
            flex-wrap: nowrap;
            height: 30px;
            font-size: 14px;
            padding: 0 14px;
            white-space: nowrap;
        }
    }


    .edit-profile {
        padding-top: 20px!important;
        padding-bottom: 20px!important;

        .avatar-wrap {
            min-width: 60px;
            width: 60px;
            height: 60px;
            margin-right: 15px;
        }
    }

    .progressbar {
        background-color: #e6e6e6;
        height: 6px;
        width: 100%;
        border-radius: 3px;
        position: relative;
        overflow: hidden;

        .bar {
            position: absolute;
            left: 0;
            top: 0;
            height:100%;
            border-radius: 3px;
            background-color: $color-type19;
        }
    }

    a {
        display: flex;
        align-items: center;

        svg {
            margin-right: 30px;
        }
    }

    .horizontal-line {
        width: 100%;
        height: 1px;
        background-color: #DEDEDE;
    }

    .buy-credit {
        span {
            color: $color-type12;
        }
    }

    .language {
        a {
            display: flex;
            align-items: center;
            padding: 8px 0;
            color: $color-type18;
            font-size: 18px;
            letter-spacing: -0.74px;

            &:hover {
                color: $color-type19;
            }
        }
    }

    .privacy-terms {
        padding-bottom: 20px!important;

        a {
            display: block;
            padding: 8px 0;
            color: $color-type10;
            font-size: 14px!important;

            &:hover {
                color: $color-type19;
            }

            span.clr-gold {
                font-weight: 700;
            }

        }
        p {
            margin-top: 7px;
            font-size: 14px!important;
        }
    }

    .edit-profile__content {
        width: 100%;

        h2 {
            font-weight: 700;
            margin-bottom: 7px;
            color: $color-type18;
        }

        p {
            font-weight: 400;
            margin-bottom: 7px;
            font-size: 14px;
            color: $color-type10;
        }

        h3 {
            margin-bottom: 0;
            color: $color-type12;
            margin-top: 10px;
        }
    }

    .avatar-wrap {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        position: relative;

        img {
            object-fit: cover;
            object-position: 50% 50%;
        }

        .pending-overlay {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(#000, .6);
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: none;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(#000, .6);
                width: 30px;
                height: 30px;
                border-radius: 50%;
            }
        }
    }
</style>
